import React from 'react';

export type TimeRange = 'week' | 'month' | 'year' | 'all';

export const TIME_RANGE_OPTIONS: Array<{ value: TimeRange; label: string }> = [
  { value: 'week', label: 'This week' },
  { value: 'month', label: 'This month' },
  { value: 'year', label: 'This year' },
  { value: 'all', label: 'All' },
];

/**
 * Convert a TimeRange preset to a day count for API `days` params.
 * Returns null for 'all' (callers should omit the param or pass a large value).
 */
export function timeRangeToDays(range: TimeRange): number | null {
  switch (range) {
    case 'week':
      return 7;
    case 'month':
      return 30;
    case 'year':
      return 365;
    case 'all':
      return null;
  }
}

type Props = {
  value: TimeRange;
  onChange: (v: TimeRange) => void;
  className?: string;
};

const TimeRangeFilter: React.FC<Props> = ({ value, onChange, className = '' }) => {
  return (
    <div
      className={`flex items-center space-x-1 bg-slate-800/40 backdrop-blur-xl p-1 rounded-lg border border-slate-700/50 ${className}`}
    >
      {TIME_RANGE_OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`px-3 py-1.5 text-xs sm:text-sm rounded-md transition-all whitespace-nowrap ${
            value === opt.value
              ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-lg'
              : 'text-gray-400 hover:text-white'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default TimeRangeFilter;
